module.exports = __webpack_public_path__ + "e0751ba063ef3bd7fb5e3471cf6d4c45.svg";